module.exports = function(video) {
	'use strict'
	video.directive('livestreamDir',livestreamDir);
	livestreamDir.$inject=[];
	function livestreamDir() {
		return {
			template: require('./partial/livestream.html'),
			controller:"livestreamController",
			controllerAs:"vmls",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/livestream/js/directive/livestreamDirective.js
// module id = 640
// module chunks = 0